module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2tO53"))).then(() => parcelRequire('hEqeo'));